import React, { useState } from "react"
import axios from "axios"

interface UploadPhotoProps {
  backPath: string
  presignedS3Url: string
  method: string
  action: string
}

export default function UploadPhoto({ backPath, presignedS3Url, method, action }: UploadPhotoProps) {
  const [file, setFile] = useState(null)
  const [error, setError] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  const handleFileChange = (e) => {
    setFile(e.target.files[0])
  }

  const handleUpload = async (e) => {
    e.preventDefault()
    setError(null)
    if (submitting) return
    setSubmitting(true)

    if (!file) {
      setError("Please choose a file")
      setSubmitting(false)
      return
    }

    let url: string
    try {
      const response = await axios.get(`${presignedS3Url}?filename=${encodeURIComponent(file.name)}`)
      url = response.data.url
    } catch (e) {
      console.log(e)
      setError("Could not get Presigned S3 URL")
      setSubmitting(false)
      return
    }

    try {
      await axios.put(url, file, { headers: { "Content-Type": file.type } })
    } catch (e) {
      console.log(e)
      setError("Upload failed")
      setSubmitting(false)
      return
    }

    try {
      const data = { photoS3Url: url.split("?")[0] }
      const response = await axios({ method, url: action, data })
      if (response.status === 200 && response.data?.redirectUrl) {
        // @ts-ignore
        window.location.href = response.data.redirectUrl
      } else {
        console.log(response)
        setError("Update failed, invalid response")
      }
    } catch (e) {
      console.log(e)
      if (e.response?.status === 422) {
        setError(`Update failed: ${e.response.data.error}`)
      } else {
        setError("Update failed")
      }
    }
    setSubmitting(false)
  }

  return (
    <form encType="multipart/form-data" onSubmit={handleUpload} className="form-horizontal">
      <input type="hidden" name="back_path" value={backPath} />
      {error && <div id="error">{error}</div>}
      <div className="row" style={{ padding: "20px 0" }}>
        <input
          type="file"
          name="photo"
          id="photo"
          className="form-control"
          onChange={handleFileChange}
          accept="image/*"
          required
        />
      </div>
      <div className="form-submit" style={{ margin: 0 }}>
        <button type="submit" className="submit-button" disabled={submitting}>
          Upload
        </button>
      </div>
    </form>
  )
}
